/**
 * Created by fwt on 2018/8/20.
 */
import React, {Component} from 'react';
import "./style.less"
import {invoiceRecord,invoiceBack,cancelInvoice} from "../../../service/invoiceService"
import {List, ListView, Modal, NavBar, Icon, Toast} from "antd-mobile";
import moment from 'moment';
import {connect} from "react-redux";
const notInvoice = require('../../../common/image/notInvoice.png');
const dataError = require('../../../common/image/dataError.png');

let pageIndex = 1;
let pageSize = 10;
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class InvoiceHistory extends Component {
    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });
        this.state = {
            dataSource,
            isLoading: true,
            notDataLoading:0,
            data: [
                // {id:0,time:"2018/04/08 23:00:00",status:0,type:0,pic:"200.00",},
                // {id:1,time:"2018/04/08 23:00:00",status:0,type:0,pic:"200.00",},
                // {id:2,time:"2018/04/09 23:00:00",status:0,type:0,pic:"200.00",},
            ],
        }
    }

    componentDidMount() {
        pageIndex = 1;
        let params = {
            source:1,
            token: this.props.userInfo.token,
            data:{
                pageSize: pageSize,
                pageNum: 1
            },
        };
        this.initData(params);
    }
    initData(params) {
        invoiceRecord(params).then(res => {
            if (res.data.code == "0000") {
                if (res.data.data.list.length > 0) {
                    this._setDataSource(res.data.data);
                    // this.setState({data:res.data.data.list})
                } else {
                    this.setState({isLoading: false,notDataLoading:1});
                }
            }else {
                this.setState({notDataLoading:2,isLoading: false});
                Toast.info(res.data.msg,3)
            }
        }).catch(function (error) {
            console.log(error);
        });
    }

    //数据拼接
    _setDataSource(data) {
        const allData = [...this.state.data, ...data.list];
        this.setState({
            dataSource: this.state.dataSource.cloneWithRows(allData),
            data: allData,
        });
        if (pageIndex * pageSize >= data.total) {
            this.setState({isLoading: false});
        }
    }

    //上拉加载
    _onEndReached = () => {
        if (this.state.isLoading) {
            let params = {
                source:1,
                token: this.props.userInfo.token,
                data:{
                    pageSize: pageSize,
                    pageNum: ++pageIndex
                },
            };
            this.initData(params);
        }
    };
    backInvoice(item){
        Toast.loading('',0);
        let params = {
            source:1,
            token: this.props.userInfo.token,
            data: {
                id:item.id,
                orderSource:1,
                // ids:item.orderIds
            }
        };
        invoiceBack(params).then((res) => {
            if (res.data.code === '0000') {
                Toast.info("撤回成功",2,()=>window.location.reload());
            } else {
                Toast.info(res.data.msg,3);
            }
        })
    }
    cancelClick(item){
        Toast.loading('',0);
        let params = {
            source:1,
            token: this.props.userInfo.token,
            data: {id:item.id,}
        };
        cancelInvoice(params).then((res) => {
            if (res.data.code === '0000') {
                Toast.info("作废成功",2,()=>window.location.reload());
            } else {
                Toast.info(res.data.msg,3);
            }
        })
    }
    notData(){
        if(this.state.notDataLoading == 1){
            return <div className="noMore">
                        <img src={notInvoice} />
                        <p>暂无开票历史</p>
                    </div>
        }else if(this.state.notDataLoading == 2){
            return <div className="noMore">
                <img src={dataError} />
                <p>数据出错，请稍后再试！</p>
            </div>
        }else{
            return null
        }
    }
    getTitle(type){
        if(type == 2){
            return "城内出行"
        }
        if(type == 1){
            return "预约出行"
        }
        if(type == 4){
            return "专车预约"
        }
        if(type == 5){
            return "接送站订单"
        }
        if(type == 7){
            return "带货订单"
        }
    }
    getStatus(type){
        if(type == 0){
            return <span className="colorGray" style={{color:"#3679FE"}}>待开票</span>
        }
        if(type == 1){
            return <span className="colorGray">已开票</span>
        }
        if(type == 99){
            return <span className="colorGray" style={{color:"#EE4D4D"}}>已作废</span>
        }
    }
    backChange(v){
        if(v.status == 0){
            if(v.invoiceType == 0){
                return (
                    <div className="back" onClick={(e)=>{
                        e.stopPropagation();
                        Modal.alert('提示', <div>您确定要撤回吗?</div>, [
                            { text: '取消'},
                            { text: '确定', onPress: () => this.backInvoice(v)},
                        ])
                    }}><button>撤回</button></div>
                )
            }
            if(v.invoiceType == 1 && v.receiveType == 2 ){
                return (
                    <div className="back" onClick={(e)=>{
                        e.stopPropagation();
                        Modal.alert('提示', <div>您确定要撤回吗?</div>, [
                            { text: '取消'},
                            { text: '确定', onPress: () => this.backInvoice(v)},
                        ])
                    }}><button>撤回</button></div>
                )
            }
        }
        if(v.isSettle == 2 && v.status == 1 && v.bwyOver == 1){
            return (
                <div className="back" onClick={(e)=>{
                    e.stopPropagation();
                    Modal.alert('提示', <div>您确定要作废吗?</div>, [
                        { text: '取消'},
                        { text: '确定', onPress: () => this.cancelClick(v)},
                    ])
                }}><button className='zfck'>作废重开</button></div>
            )
        }
    }
    render() {
        const _renderRow = (i, index, rowID) => (
            <div className="invoiceBox"  key={rowID} onClick={() => this.props.history.push(`/paperInvoice/${i.id}`)}>
                <div className="time" >
                    <span className="timeText">{this.getTitle(i.orderType)}</span>
                    {this.getStatus(i.status)}
                </div>
                <div className="invoiceTime">
                    <div className="orderBox">
                        <div className="box">订单编号</div>
                        <span className="text">{
                                i.orderNum.map((res)=>{
                                    return res + "、"
                                })
                            }
                        </span>
                    </div>
                    <div className="orderBox">
                        <div className="box">申请时间</div>
                        <span>{i.applyTimeStr}</span>
                    </div>
                    <div className="orderBox">
                        <div className="box">开票类型</div>
                        <span>{i.invoiceType == 0 ? '电子发票' : '纸质发票'} {i.invoiceType == 1  ? i.receiveType == 1 ? "邮寄" : "自提" : null}</span>
                    </div>
                    <div className="orderBox">
                        <div className="box">开票金额</div>
                        <span className="colorOrange">{'¥'+i.invoiceAmountAvailable}</span>
                        {this.backChange(i)}
                    </div>
                </div>

            </div>
        );
        return (
            <div className="invoiceHistory">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
                >开票历史</NavBar>
                <div className="content">
                    {this.notData()}
                    {
                        this.state.notDataLoading == 0  ?
                            <ListView
                                className="invoiceList"
                                ref={el => this.lv = el}
                                dataSource={this.state.dataSource}
                                renderFooter={() => (this.state.isLoading ? <Icon type="loading"/> : '没有更多')}
                                renderRow={_renderRow}
                                style={{
                                    height: '100%',
                                    overflow: 'auto',
                                }}
                                onEndReached={this._onEndReached.bind(this)}
                                scrollRenderAheadDistance={300}
                                onEndReachedThreshold={30}
                            />: null
                    }

                </div>




            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Invoice/InvoiceHistory/index.js